export enum Environment {
  PRODUCTION = 'prod',
  PROTOTYPE = 'prototype'
}

export enum VqaThumbnailAppearance {
  FIRST_FRAME = 'first_frame',
  MIDDLE_FRAME = 'middle_frame'
}

export enum VlmModel {
  QWEN_30B = 'qwen-30b', // Qwen/Qwen3-VL-30B-A3B-Instruct
  GEMINI_3_1_PRO_PREVIEW = 'gemini-3.1-pro-preview',
  GPT_5_4 = 'gpt-5.4',
  SVD_SHORT = 'svd_short',
  SVD_LONG = 'svd_long',
  CUSTOM_SVD_LONG = 'custom-svd-long',
  // Value MUST match the Bedrock inference profile ID configured in the
  // Data Layer CDK (BEDROCK_VLM_IMAGE_MODELS) and the entry in the VQA
  // Agent's VLM_MODEL_REGISTRY — the string flows verbatim through the
  // Service to the Agent, which rejects any value not in the registry.
  CLAUDE_OPUS = 'us.anthropic.claude-opus-4-6-v1',
  FLYWHEEL_30B = 'flywheel-30b',
}

export enum LlmModel {
  US_SONNET_4_6 = 'us.anthropic.claude-sonnet-4-6',
  US_CLAUDE_OPUS_4_6 = 'us.anthropic.claude-opus-4-6-v1',
  US_HAIKU_4_5 = 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
  GEMINI_3_1_PRO_PREVIEW = 'gemini-3.1-pro-preview',
  GEMINI_3_1_FLASH_LITE_PREVIEW = 'gemini-3.1-flash-lite-preview',
  GEMINI_3_FLASH_PREVIEW = 'gemini-3-flash-preview',
  GEMINI_2_5_PRO = 'gemini-2.5-pro',
  GPT_5_4 = 'gpt-5.4',
  GROK_4_20 = 'grok-4.20',
}